import React from "react";
import { parsePhoneNumberFromString } from "libphonenumber-js";

interface IPhoneNumberDisplay {
	number: string;
	hasPlus: boolean;
}

const PhoneNumberDisplay: React.FC<IPhoneNumberDisplay> = ({
	number,
	hasPlus,
}) => {
	// Format phone number
	const formatPhoneNumber = (inputNumber: string): string => {
		try {
			const phoneNumber = parsePhoneNumberFromString(inputNumber);
			if (phoneNumber && phoneNumber.isValid()) {
				return phoneNumber.formatInternational(); // Formats to international format
			}
			return inputNumber; // Return original if invalid
		} catch (error) {
			console.error("Error formatting phone number:", error);
			return inputNumber; // Return original if error occurs
		}
	};

	const formattedNumber = formatPhoneNumber(!hasPlus ? "+" + number : number);

	return (
		<div>
			<span className="font-code tracking-tighter font-semibold text-nowrap">
				{formattedNumber}
			</span>
		</div>
	);
};

export default PhoneNumberDisplay;
